<div class="visitor-profil-container">
  @if (data$ | async; as data) {
  <div class="profile-card">
    <div class="img-section">
      <img
        [src]="data.user.imgUrl | versionedImageUrl : data.user.profileImageUpdatedAt"
        alt="profil"
      />
      @if (data.user.id !== myId) {
      <button class="options-button" type="button" (click)="toggleMenu()" aria-label="Options">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <circle cx="12" cy="12" r="1" />
          <circle cx="19" cy="12" r="1" />
          <circle cx="5" cy="12" r="1" />
        </svg>
      </button>
      @if (isMenuOpen()) {
      <div class="dropdown-menu">
        <button
          type="button"
          class="menu-item report"
          (click)="openReportModal(data.user, data.saloonId)"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
            />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
          Signaler
        </button>
        <button type="button" class="menu-item block" (click)="openBlockConfirm(data.user)">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
          </svg>
          Bloquer
        </button>
      </div>
      } }
    </div>
    <div class="info-section">
      <div class="header-row">
        <h1>{{ data.user.userName }}, {{ data.user.age }} ans</h1>
        <span class="city-tag">
          <img src="assets/icons/location.svg" alt="" aria-hidden="true" />
          <span>{{ data.user.city || 'Ville non renseignée' }}</span>
        </span>
      </div>
      <div class="divider" aria-hidden="true"></div>
      <div class="about-section">
        <h2>À propos</h2>
        <p>{{ data.user.description || '' }}</p>
      </div>
    </div>
  </div>
  @if (data.user.id !== myId) {
  <button
    class="action-button"
    [class.wink]="!winkSent"
    [class.wink-sent]="winkSent"
    type="button"
    (click)="wink()"
    [disabled]="winkSent"
  >
    {{ winkSent ? "Clin d'œil envoyé !" : "Envoyer un clin d'œil" }}
  </button>
  }

  <!-- Modal de signalement -->
  @if (showReportModal() && reportModalData()) {
  <app-report-modal
    [data]="reportModalData()!"
    (closed)="closeReportModal()"
    (reported)="onReported()"
  ></app-report-modal>
  } }
</div>

<!-- Modal de confirmation de blocage — en dehors du conteneur pour éviter overflow:hidden -->
@if (showBlockConfirm()) {
<div
  class="modal-overlay"
  (click)="cancelBlock()"
  (keyup.escape)="cancelBlock()"
  tabindex="0"
  role="dialog"
>
  <div
    class="modal-content"
    (click)="$event.stopPropagation()"
    (keyup.escape)="$event.stopPropagation()"
    role="document"
  >
    <div class="modal-header">
      <div class="icon-container">
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
        </svg>
      </div>
      <h2>Bloquer {{ blockTargetName() }} ?</h2>
      <button type="button" class="close-btn" (click)="cancelBlock()" aria-label="Fermer">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <div class="modal-body">
      <p class="instruction">
        Vous ne verrez plus ses messages, et vous n'apparaîtrez plus l'un pour l'autre dans ce
        saloon.
      </p>
      <div class="reason-list">
        @for (reason of blockReasons; track reason.value) {
        <button
          type="button"
          class="reason-item"
          [class.selected]="selectedBlockReason() === reason.value"
          (click)="selectBlockReason(reason.value)"
        >
          <span class="reason-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="16" x2="12" y2="12" />
              <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
          </span>
          <span class="reason-label">{{ reason.label }}</span>
          @if (selectedBlockReason() === reason.value) {
          <span class="check-icon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </span>
          }
        </button>
        }
      </div>
      <div class="description-section">
        <label for="block-description">Description (optionnel)</label>
        <textarea
          id="block-description"
          rows="3"
          maxlength="500"
          placeholder="Ajoutez un détail si nécessaire"
          [value]="blockDescription()"
          (input)="updateBlockDescription($event)"
        ></textarea>
        <span class="char-count">{{ blockDescription().length }} / 500</span>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn-cancel" (click)="cancelBlock()">Annuler</button>
      <button
        type="button"
        class="btn-submit"
        (click)="confirmBlock()"
        [disabled]="blockLoading() || !selectedBlockReason()"
      >
        {{ blockLoading() ? 'Blocage...' : 'Bloquer' }}
      </button>
    </div>
  </div>
</div>
}
